import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogActions, DialogContent, DialogTitle} from 'views/components';
import {MobileStepper, Box, Button} from 'views/components';
import {KeyboardArrowLeft, KeyboardArrowRight} from 'views/icons';
import {Translate, translate} from 'views/module';

import STEPS_COMPONENTS from './steps';

const CreateRecurrence = (props) => {
  const clientData = props.clientData;
  const [activeStep, setActiveStep] = React.useState(0);
  const [eventType, setEventType] = React.useState(null);
  const [newEvent, setNewEvent] = React.useState({});
  const [isStepValid, setIsStepValid] = React.useState(false);

  const {onClose, addEvent} = props;

  const updateEventInfo = (func) => {
    setNewEvent((e) => {
      const info = e.info;
      const newInfo = func(info);
      return {
        ...e,
        info: newInfo,
      };
    });
  };

  const updateEventData = (func) => {
    setNewEvent((e) => {
      const data = e.eventData;
      const newData = func(data);
      return {
        ...e,
        eventData: newData,
      };
    });
  };

  const updateRecurrenceData = (func) => {
    setNewEvent((e) => {
      const data = e.recurrenceData;
      const newData = func(data);
      return {
        ...e,
        recurrenceData: newData,
      };
    });
  };

  const updateLiveInData = (func) => {
    setNewEvent((e) => {
      const data = e.liveInData;
      const newData = func(data);
      return {
        ...e,
        liveInData: newData,
      };
    });
  };

  const updateCaregiverData = (func) => {
    setNewEvent((e) => {
      const data = e.caregiverData;
      const newData = func(data);
      return {
        ...e,
        caregiverData: newData,
      };
    });
  };

  const updateBreakDetails = (func) => {
    setNewEvent((e) => {
      const data = e.breaks;
      const newData = func(data);
      return {
        ...e,
        breaks: newData,
      };
    });
  };

  // Handle moving to the next step
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  // Handle moving to the previous step
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  // Handle the final submit
  const handleSubmit = () => {
    addEvent(eventType, newEvent);
  };

  const CurrentStep = STEPS_COMPONENTS[activeStep];
  const isReviewStep = activeStep === STEPS_COMPONENTS.length - 2;
  const isLastStep = activeStep === STEPS_COMPONENTS.length - 1;

  let stepText = translate('client.ClientDetail.Scheduling.ScheduleDetail.Action.Next');
  if (isReviewStep) {
    stepText = translate('client.ClientDetail.Scheduling.ScheduleDetail.Action.Review');
  } else if (isLastStep) {
    stepText = translate('client.ClientDetail.Scheduling.ScheduleDetail.Action.Create');
  }

  return (
    <Dialog onClose={onClose} open={true} maxWidth="sm" fullWidth>
      <DialogTitle onClose={onClose}>
        <Translate expression="client.ClientDetail.Scheduling.ScheduleSetupWizard" />
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            m: 1,
          }}
        >
          <CurrentStep
            eventType={eventType}
            setEventType={setEventType}
            newEvent={newEvent}
            clientData={clientData}
            updateEventInfo={updateEventInfo}
            updateEventData={updateEventData}
            updateRecurrenceData={updateRecurrenceData}
            updateLiveInData={updateLiveInData}
            updateCaregiverData={updateCaregiverData}
            updateBreakDetails={updateBreakDetails}
            isStepValid={isStepValid}
            setIsStepValid={setIsStepValid}
            handleNext={handleNext}
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <Box sx={{width: '100%'}}>

          <MobileStepper
            variant="progress"
            steps={STEPS_COMPONENTS.length}
            position="static"
            activeStep={activeStep}
            nextButton={
              <Button
                variant={'text'}
                size="small"
                onClick={isLastStep ? handleSubmit : handleNext}
                disabled={!isStepValid}
              >
                {stepText}
                <KeyboardArrowRight />
              </Button>
            }
            backButton={
              <Button
                variant={'text'}
                size="small"
                onClick={handleBack} disabled={activeStep === 0}
              >
                <KeyboardArrowLeft />
                <Translate expression='client.ClientDetail.Scheduling.ScheduleDetail.Action.Back'/>
              </Button>
            }
          />
        </Box>
      </DialogActions>
    </Dialog>
  );
};

CreateRecurrence.propTypes = {
  onClose: PropTypes.func.isRequired,
  addEvent: PropTypes.func.isRequired,
  clientData: PropTypes.object.isRequired,
};

export default React.memo(CreateRecurrence);
